import { useCallback } from "react"
import PropTypes from "prop-types"
import { DATE, PERIOD, SEARCHABLE_MENU_ITEM } from "helpers/shapes"
import { Card, Paper } from "@mui/material"
import PeriodSelector from "components/period-selector"
import SelectedDate from "components/selected-date"
import SearchableMenu from "components/searchable-menu"
import { chain } from "lodash"
import { useRouterPath } from "hooks/router"

export default function FactorTrendsHeader({
  earliestDate,
  latestDate,
  startDate,
  endDate,
  selectedDate,
  period,
  setPeriod,
  addNotification,
  resetDate,
  firstDate,
  adjusted,
  datesWithLabels,
  selectDisplayType,
  menuItems,
}) {
  const path = useRouterPath()
  const selectedDisplayType = chain(path.path)
    .split("/")
    .nth(5)
    .value()

  const handleSetPeriod = useCallback(change => {
    if (!change.startDate) {
      setPeriod(change)
      return
    }

    if (change.adjusted.startDate || change.adjusted.endDate) {
      const from = change.adjusted.startDate || change.startDate
      const to = change.adjusted.endDate || change.endDate
      addNotification("info", null, `The selected dates have been adjusted to the nearest available date range: ${from} to ${to}.`)
    }

    setPeriod({
      startDate: change.adjusted.startDate || change.startDate,
      endDate: change.adjusted.endDate || change.endDate,
    })
  }, [setPeriod, addNotification])

  return (
    <Card square elevation={1} className="modules_factor-trends-header">
      <Paper square elevation={0} className="date-wrapper">
        <div className="label">
          <SearchableMenu
            items={menuItems}
            current={selectedDisplayType}
            onSelect={selectDisplayType}
            hideSearchBox
          />
        </div>
        <PeriodSelector {...{
          periodAdjusted: adjusted,
          earliestDate,
          latestDate,
          startDate: firstDate || startDate,
          endDate,
          period,
          onChange: handleSetPeriod,
          datesWithLabels,
        }}
        />
        {selectedDate < endDate && <SelectedDate date={selectedDate} resetHandler={resetDate} />}
      </Paper>
    </Card>
  )
}

FactorTrendsHeader.propTypes = {
  earliestDate: DATE,
  latestDate: DATE,
  startDate: DATE,
  endDate: DATE,
  selectedDate: DATE,
  period: PERIOD.isRequired,
  setPeriod: PropTypes.func,
  addNotification: PropTypes.func,
  resetDate: PropTypes.func,
  firstDate: PropTypes.string,
  adjusted: PropTypes.bool,
  datesWithLabels: PropTypes.bool,
  selectDisplayType: PropTypes.func,
  menuItems: PropTypes.arrayOf(SEARCHABLE_MENU_ITEM),
}
